export let FirstMenuDataTransform = {
  name: 'data_transformation',
  title: 'Edit data transformations',
  shortcut: 'f'
}

export function validateFilter(str) {
  if ((str.startsWith("{") && str.endsWith("}")) ||
    (str.startsWith("[") && str.endsWith("]")))
    try {
      JSON.parse(str)
    } catch (error) {
      return false;
    }
  else if (!(str.startsWith("(") && str.endsWith(")"))) return false;
  return true;
}